import { match, P } from "ts-pattern"
import { SanityLocationFilter } from "./sanity/sanity-types"

export const matchesAny = (
    filters: (SanityLocationFilter | undefined)[] | undefined,
    countryPath: string | undefined,
): boolean => {
    if (!filters || !(filters.length > 0)) return true

    return filters.some((filter) => {
        return match(filter)
            .with({ _type: "locationFilter", locationFilter: P.string }, ({ locationFilter }) => {
                return countryPath && isMatch(countryPath, locationFilter)
            })

            .otherwise(() => false)
    })
}

const isMatch = (countryPath: string | undefined, locationFilter: string): boolean => {
    return score(countryPath || "")(locationFilter) >= 0
}

const score = (countryPath: string | null) => {
    const segments = splitToSegments(countryPath)
    return (filter: string | undefined): number => {
        if (!filter || filter === "*") return 0
        const filterSegments = splitToSegments(filter)
        return startsWith(segments, filterSegments) ? filterSegments.length : -1
    }
}

const splitToSegments = (value: string | null) => (value ? value.split("/") : [])

const startsWith = (longer: string[], shorter: string[]): boolean => {
    return (
        shorter.length === 0 ||
        (longer.length > 0 &&
            shorter[0].toUpperCase() === longer[0].toUpperCase() &&
            startsWith(tail(longer), tail(shorter)))
    )
}

const tail = <T>([_, ...tail]: T[]) => tail
